import { X } from "lucide-react";
import { formatCurrency } from "@vaulzo/core/constants";

const underline =
  "border-0 border-b-[1.5px] border-vaulzo-input-line bg-transparent py-2 text-vaulzo-ink outline-none transition-colors placeholder:text-vaulzo-subtle focus:border-vaulzo-accent";

/**
 * Row-based editor for loans given out (money owed TO you): who/what and
 * the outstanding amount.
 */
export default function LoanHoldingsEditor({ holdings, setHoldings }) {
  const patchRow = (i, patch) =>
    setHoldings((rows) => rows.map((h, idx) => (idx === i ? { ...h, ...patch } : h)));
  const removeRow = (i) => setHoldings((rows) => rows.filter((_, idx) => idx !== i));
  const addRow = () => setHoldings((rows) => [...rows, { label: "", amount: "" }]);

  const total = holdings.reduce((s, h) => {
    const amt = parseFloat(h.amount);
    return amt > 0 ? s + amt : s;
  }, 0);

  return (
    <div className="block">
      <div className="mb-3 flex items-baseline justify-between">
        <span className="text-[13px] font-semibold text-vaulzo-muted">Loans given</span>
        <span className="text-[12px] text-vaulzo-fainter">Money owed to you</span>
      </div>

      {holdings.map((h, i) => (
        <div key={i} className="flex items-center gap-4 border-b border-vaulzo-row py-3 first:pt-1 last:border-b-0">
          <input
            value={h.label}
            onChange={(e) => patchRow(i, { label: e.target.value })}
            placeholder="e.g. Loan to Ramesh"
            required
            className={`min-w-0 flex-1 text-[14px] ${underline}`}
          />
          <label className="w-[140px]">
            <span className="sr-only">Amount (₹)</span>
            <input
              type="number"
              step="any"
              min="0"
              inputMode="numeric"
              required
              value={h.amount}
              onChange={(e) => patchRow(i, { amount: e.target.value })}
              placeholder="₹ amount"
              className={`num w-full text-[15px] font-semibold ${underline}`}
            />
          </label>
          <button
            type="button"
            onClick={() => removeRow(i)}
            disabled={holdings.length === 1}
            aria-label="Remove loan"
            className="flex w-5 flex-none justify-center text-vaulzo-bar transition-colors hover:text-vaulzo-danger disabled:opacity-30"
          >
            <X className="h-4 w-4" strokeWidth={1.7} />
          </button>
        </div>
      ))}

      <button
        type="button"
        onClick={addRow}
        className="mt-3 text-[13px] font-semibold text-vaulzo-accent transition-colors hover:text-vaulzo-accent-hover"
      >
        + Add loan
      </button>

      {total > 0 && (
        <div className="num mt-4 rounded-xl bg-vaulzo-row/60 px-4 py-3 text-[13px] text-vaulzo-muted">
          Total <span className="font-semibold text-vaulzo-ink">{formatCurrency(total)}</span>
        </div>
      )}
    </div>
  );
}
